import { State, process } from '@progress/kendo-data-query';
import { Component, Renderer2, NgZone, AfterViewInit, OnInit, OnDestroy, ViewEncapsulation, Input, ElementRef } from '@angular/core';
import { Observable, Subscription, fromEvent } from 'rxjs';
import { tap, take } from 'rxjs/operators';
import { RowClassArgs } from '@progress/kendo-angular-grid';
import { MfFormControlComponent } from '../mf-form-control.component';

const tableRow = node => node.tagName.toLowerCase() === 'tr';

const closest = (node, predicate) => {
  while (node && !predicate(node)) {
    node = node.parentNode;
  }

  return node;
};


@Component({
  selector: 'app-mf-multi-instance-grid',
  templateUrl: './mf-multi-instance-grid.component.html',
  styleUrls: ['./mf-multi-instance-grid.component.css']
})
export class MfMultiInstanceGridComponent implements OnInit {
  private _data: any = new Array();
  @Input() public parent: MfFormControlComponent;
  @Input() public group: any;
  @Input() public multiInstanceFormFields: any = new Array();
  public get formFields() {
    return this.multiInstanceFormFields.length > 0 ? this.multiInstanceFormFields[0].formFields : new Array();
  }
  @Input() public set data(val) {
    this._data = val;
    if (val)
      this.dataStateChange(this.state);
  }
  public get data() {
    return this._data;
  }
  public state: State = {
    skip: 0,
    take: 1000000,
    sort: [{field: 'sortOrder', dir: "asc"}]
  };
  public gridData: any = process(this.data, this.state);
  //private currentSubscription: Subscription;
  constructor(private renderer: Renderer2, private zone: NgZone, private elem: ElementRef) { }

  ngOnInit(): void {
    this.parent.multiInstanceDataChange.subscribe(o => {
      this.dataStateChange(this.state);
    });
  }

  public moveUp(rowData) {
    var moveTo = this.data.filter(o => { return o.sortOrder == rowData.sortOrder - 1 });
    if (moveTo.length > 0)
      moveTo[0].sortOrder = moveTo[0].sortOrder + 1;
    rowData.sortOrder = rowData.sortOrder - 1;
    this.dataStateChange(this.state);
  }
  public moveDown(rowData) {
    var moveTo = this.data.filter(o => { return o.sortOrder == rowData.sortOrder + 1 });
    if (moveTo.length > 0)
      moveTo[0].sortOrder = moveTo[0].sortOrder - 1;
    rowData.sortOrder = rowData.sortOrder + 1;
    this.dataStateChange(this.state);
  }
  public ngAfterViewInit(): void {
   // this.currentSubscription = this.handleDragAndDrop();
  }

  public ngOnDestroy(): void {
  //  this.currentSubscription.unsubscribe();
  }

  public dataStateChange(state: State): void {
    this.state = state;
    this.gridData = process(this.data, this.state);
   // this.currentSubscription.unsubscribe();
    //this.zone.onStable.pipe(take(1))
    //  .subscribe(() => this.currentSubscription = this.handleDragAndDrop());
  }

  //public rowCallback(context: RowClassArgs) {
  //  return {
  //    dragging: context.dataItem.dragging
  //  };
  //}

  //private handleDragAndDrop(): Subscription {
  //  const sub = new Subscription(() => { });
  //  let draggedItemIndex;
  //  var self = this;
  //  const tableRows :any = Array.from(self.elem.nativeElement.querySelectorAll('.k-grid tr'));
  //  tableRows.forEach(item => {
  //    this.renderer.setAttribute(item, 'draggable', 'true');
  //    const dragStart = fromEvent<DragEvent>(item, 'dragstart');
  //    const dragOver = fromEvent(item, 'dragover');
  //    const dragEnd = fromEvent(item, 'dragend');

  //    sub.add(dragStart.pipe(
  //      tap(({ dataTransfer }) => {
  //        try {
  //          const dragImgEl = document.createElement('span');
  //          dragImgEl.setAttribute('style', 'position: absolute; display: block; top: 0; left: 0; width: 0; height: 0;');
  //          document.body.appendChild(dragImgEl);
  //          dataTransfer.setDragImage(dragImgEl, 0, 0);
  //        } catch (err) {
  //          // IE doesn't support setDragImage
  //        }
  //        try {
  //          // Firefox won't drag without setting data
  //          dataTransfer.setData('application/json', '');
  //        } catch (err) {
  //          // IE doesn't support MIME types in setData
  //        }
  //      })
  //    ).subscribe(({ target }) => {
  //      const row: HTMLTableRowElement = <HTMLTableRowElement>target;
  //      draggedItemIndex = row.rowIndex;
  //      const dataItem = self.gridData.data[draggedItemIndex];
  //      dataItem.dragging = true;
  //    }));

  //    sub.add(dragOver.subscribe((e: any) => {
  //      e.preventDefault();
        
  //      const dropIndex = closest(e.target, tableRow).rowIndex;
  //      if (draggedItemIndex == dropIndex)
  //        return;
  //      const dropItem = self.gridData.data[dropIndex];
  //      const dataItem = self.gridData.data[draggedItemIndex];

  //      draggedItemIndex = dropIndex;
  //      //self.zone.run(() =>
  //      self.data.splice(dropIndex, 0, dataItem)
  //        self.dataStateChange(self.state)
  //      //);
  //    }));

  //    sub.add(dragEnd.subscribe((e: any) => {
  //      e.preventDefault();
  //      const dataItem = self.gridData.data[draggedItemIndex];
  //      dataItem.dragging = false;
  //    }));
  //  });

  //  return sub;
  //}
}
